import { extractErrorMessage, useAvatarUpload } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { useNotification } from '@sib/notifications';
import { Card, CardContent, UserAvatar } from '@sib/ui';

interface UserWelcomeCardProps {
  name: string;
  avatarUrl: string;
  email: string;
}

export const UserWelcomeCard = ({
  email,
  name,
  avatarUrl,
}: UserWelcomeCardProps) => {
  const { t } = useTranslation();
  const initials = name
    .split(' ')
    .map(n => n[0])
    .join('')
    .slice(0, 2);

  const { open } = useNotification();
  const avatarUpload = useAvatarUpload({
    onError: error => {
      const errorMessage = extractErrorMessage(
        error,
        t('avatarUpload.errorMessage')
      );
      open({
        type: 'error',
        message: errorMessage,
      });
    },
    onSuccess: () =>
      open({
        type: 'success',
        message: t('avatarUpload.successMessage'),
      }),
  });

  return (
    <Card className="mx-auto w-full max-w-sm border-none shadow-none">
      <CardContent className="flex flex-col items-center space-y-4 pt-6">
        <div className="overflow-hidden rounded-full border-8 border-white drop-shadow-md">
          <UserAvatar
            avatarImageProps={{
              avatarUrl,
            }}
            avatarFallbackProps={{
              initials,
            }}
            uploadSettings={avatarUpload}
          />
        </div>
        <div className="w-full space-y-1 text-center">
          <p className="text-muted-foreground text-center leading-[14px]">
            {t('welcome')}
          </p>
          <p className="text-primary text-center leading-5 font-medium break-words">
            {email}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
